import React from 'react';
import ExamSubjects from './ExamSubjects';

export default function ExamShortNotesSubject() {
  return <ExamSubjects categoryId={4} />;
}
